import React, { FC, useEffect, useState } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils, { injectErrorPropToConfig } from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'

const IndividualFinancialSituationForm: FC<FormProps> = props => {
  const [error, setError] = useState({grossAmount: false, netAmount: false})
  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    toggleShowByName,
    handleInputChange,
    handleSubmit } =
    useForm(props.fetchedData, config, submitForm)

  useEffect(() => {
    toggleShowByName('grossAnnualStateAmount', formData?.grossAnnualIncomeType?.value === '0')
  },[formData?.grossAnnualIncomeType?.value])

  useEffect(() => {
    toggleShowByName('netAssetsStateAmount', formData?.netAssestsType?.value === '0')
  },[formData?.netAssestsType?.value])

  useEffect(() => {
    if(parseInt(formData?.grossAnnualStateAmount?.value) >= 25000){
      setError(prev => ({...prev, grossAmount: true}))
      injectErrorPropToConfig(config, parseInt(formData?.netAssetsStateAmount?.value) >= 25000 ? ['grossAnnualStateAmount', 'netAssetsStateAmount'] : ['grossAnnualStateAmount'])
    } else {
      setError(prev => ({...prev, grossAmount: false}))
      injectErrorPropToConfig(config, parseInt(formData?.netAssetsStateAmount?.value) >= 25000 ? ['netAssetsStateAmount'] : [''])
    }
  },[formData?.grossAnnualStateAmount?.value])

  useEffect(() => {
    if(parseInt(formData?.netAssetsStateAmount?.value) >= 25000){
      setError(prev => ({...prev, netAmount: true}))
      injectErrorPropToConfig(config, parseInt(formData?.grossAnnualStateAmount?.value) >= 25000 ? ['grossAnnualStateAmount', 'netAssetsStateAmount'] : ['netAssetsStateAmount'])
    } else {
      setError(prev => ({...prev, netAmount: false}))
      injectErrorPropToConfig(config, parseInt(formData?.grossAnnualStateAmount?.value) >= 25000 ? ['grossAnnualStateAmount'] : [''])
    }
  },[formData?.netAssetsStateAmount?.value])

  useEffect(() => {
    const rentPropertyOwnership = (document.querySelector('input[name="rentPropertyOwnership"]') as HTMLInputElement)
    const severalPropertyOwnership = (document.querySelector('input[name="severalPropertyOwnership"]') as HTMLInputElement)
    const ownHousePropertyOwnership = (document.querySelector('input[name="ownHousePropertyOwnership"]') as HTMLInputElement)

    if(formData?.rentPropertyOwnership?.value){
      severalPropertyOwnership.checked = false
      ownHousePropertyOwnership.checked = false
      severalPropertyOwnership.disabled = true
      ownHousePropertyOwnership.disabled = true
    }

    if(formData?.ownHousePropertyOwnership?.value){
      severalPropertyOwnership.checked = false
      rentPropertyOwnership.checked = false
      severalPropertyOwnership.disabled = true
      rentPropertyOwnership.disabled = true
    }

    if(formData?.severalPropertyOwnership?.value){
      rentPropertyOwnership.checked = false
      ownHousePropertyOwnership.checked = false
      rentPropertyOwnership.disabled = true
      ownHousePropertyOwnership.disabled = true
    }

    if(!formData?.rentPropertyOwnership?.value && !formData?.ownHousePropertyOwnership?.value && !formData?.severalPropertyOwnership?.value) {
      rentPropertyOwnership.disabled = false
      severalPropertyOwnership.disabled = false
      ownHousePropertyOwnership.disabled = false
    }

  },[formData?.rentPropertyOwnership?.value, formData?.ownHousePropertyOwnership?.value, formData?.severalPropertyOwnership?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>{t('onboarding.forms.IndividualAccount.FinancialSituationForm.title')}</FormTitle>
      </FormHeader>
      {utils.sectionBuilder(config, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          {!props.disablePrev && (
            <Button label={t('onboarding.main.backButton')} version={2} disabled={props.disablePrev} />
          )}
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={
              emptyValidation ||
              (!formData?.rentPropertyOwnership?.value && !formData?.ownHousePropertyOwnership?.value && !formData?.severalPropertyOwnership?.value) ||
              (formData?.grossAnnualIncomeType?.value === '0' && error.grossAmount) ||
              (formData?.netAssestsType?.value === '0' && error.netAmount)
            }
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default IndividualFinancialSituationForm
